// TT => ToolTip
export const TT_SAVE = "Guardar";
export const TT_EDIT = "Editar";
export const TT_VIEW = "Ver";
export const TT_DELETE = "Eliminar";
export const TT_UPD_PRICES = "Actualizar precios";
export const TT_COMPONENTS = "Componentes";
export const TT_PRODUCTS = "Productos";
export const TT_BENEFIT = "Beneficios";
export const TT_TABOPTION = "Tabs";
export const TT_SCHEDULE = "Horarios";
export const TT_DETAILS = "Detalles";
export const TT_GALLERY = "Galería";
export const TT_CLOSE = "Cerrar";

export const TT_NODE_ADD = "Agregar nodo";
export const TT_ADD_MODULE = "Agregar nuevo modulo";
export const TT_FIND_PATH = "Encontrar camino";
export const TT_NEXT = "Siguente";
export const TT_PREV = "Anterior";
export const TT_SEARCH = "Actualizar";
export const TT_EMPTY = "Vaciar";
export const TT_HISTORY = "Ver historial";
export const TT_DISH_DRINK = "Platillos y Bebidas";
export const TT_TREATMENTS = "Tratamientos";

export const TT_ADD = "Agregar";
export const TT_ADD_AT_END = "Agregar al final";
export const TT_ADD_AT_START = "Agregar al inicio";
export const TT_REMOVE = "Remover";
export const TT_SEARCH_NEAREST = "Buscar puntos cercanos";
export const TT_SEND_ALERT = "Enviar notificación";
export const TT_TRANSLATE = "Traducir";
export const TT_TRANSLATE_INTO_LANGUAGE = "Traducir al idioma";
